export function Wrapper({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative h-[273px] w-[318px] bg-gray-500 bg-opacity-75 transition-opacity">
      <div className="absolute inset-0 select-none bg-[#201A91]">
        {children}
      </div>
    </div>
  );
}
